import useSWR from 'swr';
import { useCurrentLocale } from '@locales/client';
import { fetcherWithToken } from '@/shared/api/fetcher';

const useBanners = ({ enabled }) => {
  const lang = useCurrentLocale();
  const { data, error, isLoading } = useSWR(
    enabled ? `/banners?lang=${lang}` : null,
    fetcherWithToken
  );

  return {
    data,
    error,
    isLoading,
  };
};

export { useBanners };
